<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%;height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(0, 0, 0, 1)">
        <template v-for="sub in energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 49px);display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;overflow: hidden;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" :filter-node-method="filterNode" node-key='id'
                 :default-expanded-keys="expandKeys" ref="tree" class="aside-tree" show-checkbox :default-checked-keys="checkedKey">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <span style="margin-left: 24px;">时间：</span>
          <el-radio-group v-model="radio" @change="selBack" style="margin-left: 8px;" size="small">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
          <el-date-picker v-model="startDate" style="width: 140px;margin-left: 16px" :type="type"
                           placeholder="选择日期" :value-format="format" :clearable="false"/>
          <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">查询</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow-y: auto;height: calc(100% - 49px);width: 100%;">
          <el-row style="height: calc(50% - 1px);width: 100%;">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span v-if="curveType === '3'" style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">数据曲线</span>
              <span v-else-if="curveType === '2'" style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">数据对比</span>
            </el-row>
            <common-charts :init-options="initOptions" class="electric-parameter-charts"
                           :index="200" :key="timestamp" :options="chartData" autoresize :style="{'height': ((bgSize.height - 244) / 2) + 'px', 'width': (bgSize.width - 452) + 'px'}" />
          </el-row>
          <el-row style="height: 1px;width: 100%;background-color: #FFF" />
          <el-row style="height: calc(50% - 1px);width: 100%;" class="table">
            <el-row v-show="curveType === '3'" style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;line-height: 48px;">
              <el-menu :default-active="0" class="horizontal-menu" @select="panelSelect"
                       mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(242, 242, 242, 1)">
                <el-menu-item class="horizontal-menu-item" :key="0" :index="0">
                  <span style="font-size: 14px;">分析</span>
                </el-menu-item>
                <el-menu-item class="horizontal-menu-item" :key="1" :index="1">
                  <span style="font-size: 14px;">说明</span>
                </el-menu-item>
              </el-menu>
            </el-row>
            <el-row v-show="curveType === '2'" style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">分析</span>
            </el-row>
            <el-row v-if="curveType === '3'" style="width: 100%; height: calc(100% - 48px)">
              <el-table v-show="selPanel === 0" border fit :data="tableData" height="100%" width="100%" ref="tableData">
                <el-table-column v-for="(item, i) in tableProps1" :key="i+tableData"
                                 :prop="item.prop" :label="item.unit ? item.label + '(' + unit + ')' : item.label" :width="item.width">
                </el-table-column>
              </el-table>
              <el-row v-show="selPanel === 1" style="width: 99%; height: 100%;text-align: left;font-size: 14px;margin-left: 1%;">
                <el-row style="height: 32px;line-height: 32px;margin-top: 8px;">离散率用来表示数据的离散程度，离散率越大表示数据的波动性越大，反之则表示数据越稳定。</el-row>
                <el-row style="height: 32px;line-height: 32px;">在一定程度上可以反映负载的健康情况。</el-row>
              </el-row>
            </el-row>
            <el-table v-else border fit :data="tableData" height="calc(100% - 48px)" width="100%" ref="tableData">
              <el-table-column v-for="(item,i) in tableProps2" :key="i+tableData"
                               :prop="item.prop" :label="item.unit ? item.label + '(' + unit + ')' : item.label" :width="item.width">
              </el-table-column>
            </el-table>
          </el-row>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import DateUtils from "../../../utils/DateUtils";
import buildCommonConfig from "../../../config/chart/config_common_line";
import CommonCharts from "../../common/chart/CommonCharts";
export default {
  name: "ElectricStatistics",
  components: {CommonCharts},
  data() {
    return {
      radio: '日',
      initOptions: {
        renderer: 'canvas'
      },
      initOptions1: {
        renderer: 'canvas'
      },
      initOptions2: {
        renderer: 'canvas'
      },
      timestamp: 0,
      chartData: {},
      circleData: {},
      lineData: {},
      selNode: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      type: 'date',
      dateType: 1,
      startDate: DateUtils.getYesterday().Format('yyyy-MM-dd'),
      format: 'yyyy-MM-dd',
      energyItem: [{'id': '1', 'name': '电'}, {'id': '2', 'name': '水'}, {'id': '11', 'name': '气'}, {'id': '12', 'name': '汽'}],
      bgSize: {'width': window.innerWidth, 'height': window.innerHeight},
      filterName: '',
      unit: 'kWh',
      media: '1',
      checkedKey: [],
      tableProps1: [
        {prop: "dataSum", label: "合计", unit: 1},
        {prop: "maxData", label: "最大用量", unit: 1},
        {prop: "maxTime", label: "最大用量发生时间"},
        {prop: "minData", label: "最小用量", unit: 1},
        {prop: "minTime", label: "最小用量发生时间"},
        {prop: "avgData", label: "单位时间均值", unit: 1},
        {prop: "sData", label: "离散率"}
      ],
      tableProps2: [
        {prop: "sensorInd", label: "排名"},
        {prop: "sensorName", label: "监测点"},
        {prop: "dataData", label: "用电量", unit: 1},
        {prop: "dataRatio", label: "占比"}
      ],
      tableData: [],
      curveType: '3',
      selPanel: 0
    }
  },
  created() {
    this.getTree('1')
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.bgSize.width = window.innerWidth
      this.bgSize.height = window.innerHeight
      this.timestamp = new Date().getTime()
    })
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    menuSelect(val) {
      this.tableData = []
      this.chartData = []
      this.timestamp = new Date().getTime();
      this.media = val
      this.getTree(val)
      if (val === '1') {
        this.unit = 'kWh'
      } else {
        this.unit = 'm³'
      }
    },
    panelSelect(val) {
      this.selPanel = val
    },
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          this.checkedKey = this.selNode.id.split(',')
          this.$refs.tree.setCheckedKeys([this.selNode['id']], true)
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
            this.getChartData()
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    selBack(val) {
      if(val === '年') {
        this.dateType = 3
        this.type = 'year'
        this.startDate = new Date().Format('yyyy')
        this.format = 'yyyy'
      }
      if(val === '月') {
        this.dateType = 2
        this.type = 'month'
        this.startDate = new Date().Format('yyyy-MM')
        this.format = 'yyyy-MM'
      }
      if(val === '日') {
        this.dateType = 1
        this.type = 'date'
        this.startDate = DateUtils.getYesterday().Format('yyyy-MM-dd')
        this.format = 'yyyy-MM-dd'
      }
      this.getChartData()
    },
    getChartData() {
      if (this.$refs.tree.getCheckedKeys(true).length === 0) {
        return
      }
      this.tableData = []
      this.chartData = {}
      let type = this.$refs.tree.getCheckedKeys(true).length > 1 ? '2' : '3'
      this.curveType = type
      let params = {'id': this.$refs.tree.getCheckedKeys(true).join(","), 'energy': this.media, 'dataDate': this.startDate, 'dateType': this.dateType, 'type': type}
      this.$api.energyCount.getEnergyCount(params).then(res => {
        if (res.data.hasOwnProperty('curveList')) {
          this.tableData = res.data.tableList
          let xAxis = res.data.curveList.dataName
          let data = []
          let legend = [res.data.curveList.itemName]
          data.push({
            name: '',
            type: 'bar',
            data: res.data.curveList.dataData.split(","),
            markPoint: {
              data: [
                {type: 'max', name: '最大值', itemStyle: {color: '#FF0000'}},
                {type: 'min', name: '最小值', itemStyle: {color: '#00FF00'}}
              ]
            }
          })
          this.chartData = buildCommonConfig(legend, xAxis, data, 0, this.unit);
        }
        this.timestamp = new Date().getTime();
      })
    }
  }
}
</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .electric-parameter-charts{
    width: 100%;
    margin-top: 0;
  }
  .new-electric-parameter-charts{
    width: 100%;
    padding: 0;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyAnalyse/EnergyStatistics.vue